export const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE';
export type CHANGE_LANGUAGE = typeof CHANGE_LANGUAGE;

export const TOGGLE_LANGUAGE_SELECTION_VISIBILITY = 'TOGGLE_LANGUAGE_SELECTION_VISIBILITY';
export type TOGGLE_LANGUAGE_SELECTION_VISIBILITY = typeof TOGGLE_LANGUAGE_SELECTION_VISIBILITY;

export const LOAD_LANGUAGE_SERVICE_FROM_SERVER = 'LOAD_LANGUAGE_SERVICE_FROM_SERVER';
export type LOAD_LANGUAGE_SERVICE_FROM_SERVER = typeof LOAD_LANGUAGE_SERVICE_FROM_SERVER;



// WEBPACK FOOTER //
// ./src/store/LanguageLocale/constants.ts